import { createSlice } from '@reduxjs/toolkit';
import {
  layoutTypes,
  leftSidebarTypes,
  layoutModeTypes,
  layoutWidthTypes,
  layoutPositionTypes,
  topBarThemeTypes,
  leftSideBarSizeTypes,
  leftSidebarViewTypes,
  leftSidebarImageTypes,
  preloaderTypes
} from "@velzon/constants/layout.js";

const initialState = {
  layoutType: layoutTypes.VERTICAL,
  leftSidebarType: leftSidebarTypes.DARK,
  layoutModeType: layoutModeTypes.LIGHTMODE,
  layoutWidthType: layoutWidthTypes.FLUID,
  layoutPositionType: layoutPositionTypes.FIXED,
  topBarThemeType: topBarThemeTypes.LIGHT,
  leftSideBarSizeType: leftSideBarSizeTypes.DEFAULT,
  leftSidebarViewType: leftSidebarViewTypes.DEFAULT,
  leftSidebarImageType: leftSidebarImageTypes.NONE,
  preloader: preloaderTypes.DISABLE
}

const layoutSlice = createSlice({
  name: 'layoutSlice',
  initialState,
  reducers: {
    changeLayout: (state, action) => {
      state.layoutType = action.payload
    },
    changeLayoutMode: (state, action) => {
      state.layoutModeType = action.payload
    },
    changeSidebarTheme: (state, action) => {
      state.leftSidebarType = action.payload
    },
    changeLayoutWidth: (state, action) => {
      state.layoutWidthType = action.payload
    },
    changeLayoutPosition: (state, action) => {
      state.layoutPositionType = action.payload
    },
    changeTopBarTheme: (state, action) => {
      state.topBarThemeType = action.payload
    },
    changeLeftSidebarSizeType: (state, action) => {
      state.leftSideBarSizeType = action.payload
    },
    changeLeftSidebarViewType: (state, action) => {
      state.leftSidebarViewType = action.payload
    },
    changeSidebarImageType: (state, action) => {
      state.leftSidebarImageType = action.payload
    },
    resetValue: (state) => {
      state.layoutType = layoutTypes.VERTICAL;
      state.leftSidebarType = leftSidebarTypes.DARK;
      state.layoutModeType = layoutModeTypes.LIGHTMODE;
      state.layoutWidthType = layoutWidthTypes.FLUID;
      state.layoutPositionType = layoutPositionTypes.FIXED;
      state.topBarThemeType = topBarThemeTypes.LIGHT;
      state.leftSideBarSizeType = leftSideBarSizeTypes.DEFAULT;
      state.leftSidebarViewType = leftSidebarViewTypes.DEFAULT;
      state.leftSidebarImageType = leftSidebarImageTypes.NONE;
      state.preloader = preloaderTypes.DISABLE;
    },
    changePreLoader: (state, action) => {
      state.preloader = action.payload
    }
  }
});

export const {
  changeLayout,
  changeLayoutMode,
  changeSidebarTheme,
  changeLayoutWidth,
  changeLayoutPosition,
  changeTopBarTheme,
  changeLeftSidebarSizeType,
  changeLeftSidebarViewType,
  changeSidebarImageType,
  resetValue,
  changePreLoader
} = layoutSlice.actions;

export default layoutSlice.reducer;